import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { CalendarEvent } from 'angular-calendar';

@Component({
  selector: 'app-date-widget',
  templateUrl: './date-widget.component.html',
  styleUrls: ['./date-widget.component.scss'],
  providers: [DatePipe],
})
export class DateWidgetComponent implements OnInit {

  @Input() dates: { text: string, value: number }[] = [];
  @Output() handleSubmitResponse = new EventEmitter();
  @Input() canChangeStyle: any;
  @Input() clientConfigurationData: any;
  styleSheet: CSSStyleSheet | undefined;
  @ViewChild('myDropdown') myDropdown!: NgbDropdown;
  DATA: any;

  currentYear: number = new Date().getFullYear();
  currentMonth: number = new Date().getMonth();
  selectedDate: Date | null = null;
  selectedSlot: string | null = null;
  daysOfWeek: string[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  months: string[] = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];
  weeks: { date: Date; day: number; isCurrentMonth: boolean }[][] = [];
  availableSlots: any[] = []

  constructor() {
    this.generateCalendar();
  }

  ngOnInit(): void {
    console.log("dates123", this.dates);
    this.availableSlots = this.dates.map((date) => date.value);
    if (this.canChangeStyle) {
      this.DATA = this.clientConfigurationData;
      this.fnSetStyles();
    } else {
      this.fnSetDefaultStyles();
    }
  }

  // Generate calendar grid for the current month
  generateCalendar(): void {
    const firstDayOfMonth = new Date(this.currentYear, this.currentMonth, 1);
    const lastDayOfMonth = new Date(this.currentYear, this.currentMonth + 1, 0);
    const firstDayOfWeek = firstDayOfMonth.getDay();
    const lastDateOfMonth = lastDayOfMonth.getDate();

    const calendarDays: { date: Date; day: number; isCurrentMonth: boolean }[] = [];

    // Previous month's days
    for (let i = firstDayOfWeek - 1; i >= 0; i--) {
      const date = new Date(this.currentYear, this.currentMonth, -i);
      calendarDays.push({ date, day: date.getDate(), isCurrentMonth: false });
    }

    // Current month's days
    for (let day = 1; day <= lastDateOfMonth; day++) {
      const date = new Date(this.currentYear, this.currentMonth, day);
      calendarDays.push({ date, day, isCurrentMonth: true });
    }

    // Next month's days
    for (let i = 1; calendarDays.length % 7 !== 0; i++) {
      const date = new Date(this.currentYear, this.currentMonth + 1, i);
      calendarDays.push({ date, day: date.getDate(), isCurrentMonth: false });
    }

    // Divide into weeks
    this.weeks = [];
    while (calendarDays.length) {
      this.weeks.push(calendarDays.splice(0, 7));
    }
  }

  // Navigate to the previous month
  navigateToPreviousMonth(): void {
    this.currentMonth--;
    if (this.currentMonth < 0) {
      this.currentMonth = 11;
      this.currentYear--;
    }
    this.generateCalendar();
  }

  // Navigate to the next month
  navigateToNextMonth(): void {
    this.currentMonth++;
    if (this.currentMonth > 11) {
      this.currentMonth = 0;
      this.currentYear++;
    }
    this.generateCalendar();
  }

  // Select a date
  selectDate(date: Date, date1: any): void {

    console.log("Selected Date:", date);
    console.log("Selected Date:", date1);
    // if (this.isAvailable(date)) {
    this.selectedDate = date;
    this.selectedSlot = null; // Reset slot selection
    console.log("Selected Date:", this.formatDateForDisplay(date)); // Log selected date
    this.onDateSelect(this.formatDateForDisplay(date)); // Emit selected date
    // }
  }

  // Check if the date is today
  isToday(date: Date): boolean {
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  }

  // Check if the date is selected
  isSelectedDate(date: Date): boolean {
    return this.selectedDate?.getTime() === date.getTime();
  }

  // Format date for display
  formatDateForDisplay(date: Date): string {
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  // Check if a date has available slots
  isAvailable(date: Date): boolean {
    const formatedData = this.formatDateForDisplay(date)
    // return this.availableSlots[date.toISOString().split('T')[0]]?.length > 0;
    const checkDate = new Date(formatedData);

    // Normalize the date to the same format as the availableSlots array
    const formattedDate = `${checkDate.getFullYear()}-${String(checkDate.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

    // Check if the formatted date exists in the availableSlots array


    return this.availableSlots.includes(formattedDate);
  }

  // Select a slot
  selectSlot(slot: string): void {
    this.selectedSlot = slot;
  }

  // Handle submit
  onDateSelect(data: any) {
    console.log("Selected Date:", data);
    const date = new Date(data);
    
    // Manually format date in YYYY-MM-DD format in local timezone
    const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    
    console.log(formattedDate);  // Output should now be in local timezone
    this.handleSubmitResponse.emit({
      text: data,
      value: formattedDate
    });
    // this.myDropdown.close();
}


  fnSetStyles() {
    let style = document.createElement("style");
    style.appendChild(document.createTextNode(""));
    document.head.appendChild(style);
    this.styleSheet = style.sheet as CSSStyleSheet;

    this.styleSheet.insertRule(`.date-dropdown-button {
      background: `+ this.DATA.PrimaryColor + ` !important;	
    }`);

    this.styleSheet.insertRule(`.label-color {
      color: `+ this.DATA.PrimaryColor + ` !important;	
    }`);

    this.styleSheet.insertRule(`.dropdown-list input[type=radio] {
      accent-color: `+ this.DATA.PrimaryColor + ` !important;	
    }`);

    // card-header
    this.styleSheet.insertRule(`.card-header {
      background: `+ this.DATA.PrimaryColor + ` !important;	
    }`);

    //navigate-btn
    this.styleSheet.insertRule(`.navigate-btn {
      background: `+ this.DATA.PrimaryColor + ` !important;	
    }`);

  }

  fnSetDefaultStyles() {
    let style = document.createElement("style");
    style.appendChild(document.createTextNode(""));
    document.head.appendChild(style);
    this.styleSheet = style.sheet as CSSStyleSheet;
    this.styleSheet.insertRule(`.date-dropdown-button {
      background: `+ '#156087' + ` !important;	
    }`);

    this.styleSheet.insertRule(`.label-color {
      color: `+ '#156087' + ` !important;	
    }`);

    this.styleSheet.insertRule(`.dropdown-list input[type=radio] {
      accent-color: `+ '#156087' + ` !important;	
    }`);

    // card-header
    this.styleSheet.insertRule(`.card-header {
      background: `+ '#156087' + ` !important;	
    }`);

    //navigate-btn
    this.styleSheet.insertRule(`.navigate-btn {
      background: `+ '#156087' + ` !important;	
    }`);
  }
}
